import React from "react";

const formatMoney = (value, currency = "RUB") => {
  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: currency || "RUB",
      maximumFractionDigits: 2,
    }).format(Number(value || 0));
  } catch {
    return `${Number(value || 0).toFixed(2)} ${currency || "RUB"}`;
  }
};

const OfferToolbar = ({
  totals,
  currency,
  saving,
  importing,
  status,
  lastPdfUrl,
  onFinalize,
  onImportJson,
  onExportJson,
  back,
}) => (
  <div className="offer-toolbar">
    <div className="offer-toolbar__totals">
      <span>Итоговая стоимость</span>
      <strong>{formatMoney(totals?.grandTotal || 0, currency)}</strong>
      <small>
        {status === "final"
          ? "Документ уже формировался. Новая версия сохранится в истории."
          : "Перед созданием PDF проверьте предпросмотр и условия."}
      </small>
    </div>

    <div className="offer-toolbar__right">
      <div className="offer-toolbar__json">
        <span>Обмен данными</span>
        <div>
          <button
            type="button"
            className="offer-toolbar__button offer-toolbar__button--ghost"
            onClick={onImportJson}
            disabled={importing || saving}
          >
            {importing ? "Импортируем…" : "Импорт JSON"}
          </button>

          <button
            type="button"
            className="offer-toolbar__button offer-toolbar__button--ghost"
            onClick={onExportJson}
            disabled={importing || saving}
          >
            Экспорт JSON
          </button>
        </div>
      </div>

      <div className="offer-toolbar__actions">
        {lastPdfUrl && (
          <a
            className="offer-toolbar__link"
            href={lastPdfUrl}
            target="_blank"
            rel="noreferrer"
          >
            Открыть последний PDF
          </a>
        )}

        <button
          type="button"
          className="offer-toolbar__button offer-toolbar__button--primary"
          onClick={onFinalize}
          disabled={saving || importing}
        >
          {saving ? (
            <>
              <span className="offer-toolbar__spinner" />
              Формируем PDF…
            </>
          ) : (
            "Сформировать PDF"
          )}
        </button>

        <button
          type="button"
          className="offer-toolbar__button offer-toolbar__button--secondary"
          onClick={back}
        >
          К списку
        </button>
      </div>
    </div>
  </div>
);

export default OfferToolbar;
